import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';
import moment from 'moment';
import { StateStatus } from '@alycecom/utils';

import { DATE_FORMAT } from '../../../../constants/dates.constants';

import {
  changeWeek,
  meetingSlotsFail,
  meetingSlotsRequest,
  meetingSlotsSuccess,
  resetMeetingSlots,
} from './meeting.actions';
import { ISlot } from './meeting.types';

export interface IMeetingState {
  status: StateStatus;
  timezone: string;
  slots: ISlot[];
  from: string;
  to: string;
  autoDetect: boolean;
  errors: TLegacyErrors;
}

export const initialState: IMeetingState = {
  status: StateStatus.Idle,
  timezone: '',
  slots: [],
  from: moment().startOf('isoWeek').format(DATE_FORMAT),
  to: moment().endOf('isoWeek').format(DATE_FORMAT),
  autoDetect: true,
  errors: {},
};

export const meeting = createReducer<IMeetingState>({}, initialState);

meeting.on(changeWeek, (state, payload) => ({
  ...state,
  from: payload.from,
  to: payload.to,
}));

meeting
  .on(meetingSlotsRequest, state => ({
    ...state,
    status: StateStatus.Pending,
  }))
  .on(meetingSlotsSuccess, (state, payload) => ({
    ...state,
    slots: payload.slots,
    from: payload.from,
    to: payload.to,
    autoDetect: false,
    status: StateStatus.Fulfilled,
  }))
  .on(meetingSlotsFail, (state, payload) => ({
    ...state,
    slots: [],
    status: StateStatus.Rejected,
    errors: payload,
  }));

meeting.on(resetMeetingSlots, state => ({
  ...state,
  slots: [],
}));
